"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const draft_js_1 = require("draft-js");
const draftjs_filters_1 = require("draftjs-filters");
const react_1 = tslib_1.__importDefault(require("react"));
const react_draft_wysiwyg_1 = require("react-draft-wysiwyg");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const getContentStateFromProps = (props) => {
    if (props.html) {
        const { contentBlocks, entityMap } = draft_js_1.convertFromHTML(props.data);
        return draft_js_1.ContentState.createFromBlockArray(contentBlocks, entityMap);
    }
    let contentState = props.data;
    if (!contentState) {
        contentState = draft_js_1.ContentState.createFromText('');
    }
    else {
        if (typeof contentState === 'string') {
            try {
                contentState = JSON.parse(contentState);
            }
            catch (e) {
                contentState = draft_js_1.ContentState.createFromText('');
                console.error('getContentStateFromProps | Error in JSON.parse', props.data, e);
            }
        }
        try {
            contentState = draft_js_1.convertFromRaw(contentState);
        }
        catch (e) {
            contentState = draft_js_1.ContentState.createFromText('');
            console.error('getContentStateFromProps | Error in convertFromRaw', props.data, e);
        }
    }
    return contentState;
};
class TextEditor extends react_1.default.Component {
    static getDerivedStateFromProps(props, state) {
        if (props.data !== state.data) {
            const contentState = getContentStateFromProps(props);
            return {
                data: state.data,
                editorState: draft_js_1.EditorState.createWithContent(contentState),
            };
        }
        return null;
    }
    constructor(props) {
        super(props);
        const contentState = getContentStateFromProps(props);
        this.state = {
            data: props.data,
            editorState: draft_js_1.EditorState.createWithContent(contentState),
        };
    }
    onEditorChange(nextState) {
        const { editorState } = this.state;
        let filteredState = nextState;
        const contentChanged = nextState.getCurrentContent() !== editorState.getCurrentContent();
        const insertingFragment = ['insert-characters', 'insert-fragment'].includes(nextState.getLastChangeType());
        const shouldFilterPaste = contentChanged && insertingFragment;
        if (shouldFilterPaste) {
            filteredState = draftjs_filters_1.filterEditorState({
                blocks: [],
                entities: [
                    {
                        attributes: ['url'],
                        type: 'LINK',
                    },
                ],
                filterInlineStyles: [],
                maxNesting: 1,
                styles: ['BOLD'],
                whitespacedCharacters: ['\n', '\t'],
            }, filteredState);
        }
        this.setState({
            editorState: filteredState,
        }, () => {
            if (this.props.onChange) {
                this.props.onChange(this.getRaw(), this.state.editorState.getCurrentContent());
            }
        });
    }
    getRaw() {
        return draft_js_1.convertToRaw(this.state.editorState.getCurrentContent());
    }
    render() {
        let editor = (react_1.default.createElement(react_draft_wysiwyg_1.Editor, { editorState: this.state.editorState, onEditorStateChange: editorState => this.onEditorChange(editorState), toolbar: {
                blockType: {
                    inDropdown: true,
                    options: ['Normal', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                },
                options: ['inline', 'blockType', 'list', 'link', 'history', 'remove'],
            } }));
        if (this.props.isModal) {
            if (this.props.unMountOnModalClose && !this.props.isOpen) {
                editor = undefined;
            }
            return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "TextEditor", size: "lg", centered: true, isOpen: this.props.isOpen, toggle: this.props.toggle
                    ? () => {
                        this.props.toggle();
                    }
                    : undefined, onClosed: this.props.onClosed
                    ? () => {
                        this.props.onClosed();
                    }
                    : undefined },
                this.props.modalHeader && (react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: this.props.toggle
                        ? () => {
                            this.props.toggle();
                        }
                        : undefined }, this.props.modalHeader)),
                react_1.default.createElement(reactstrap_1.ModalBody, { style: {
                        minHeight: 200,
                        overflowY: 'auto',
                    } },
                    editor,
                    this.props.modalBodyFooter),
                this.props.modalFooter && (react_1.default.createElement(reactstrap_1.ModalFooter, null, this.props.modalFooter))));
        }
        return editor;
    }
}
exports.TextEditor = TextEditor;
//# sourceMappingURL=TextEditor.js.map